(function() {
    'use strict';
    //service must be lowercase since Plaid library attaches to window.Plaid
    angular.module('wbUtilities').provider('PlaidService', [function () {

        var configDefaults = {};
        this.init = function(options) {
            angular.extend(configDefaults, options);
            configDefaults.onSuccess = function() {};
        };

        this.$get = ['$rootScope', 'Request', '$q', function($rootScope, Request, $q) {
            var plaidObj = {
                enabled: true,
                loaded: false,
                errorMsg: null,
                show: true,
                addToken: null,
                bank: {
                    accountsLoaded: false,
                    imageLoaded: false,
                    public_token: null,
                    data: {},
                    meta: {},
                    id: null,
                    accounts: []
                },
                handler: null,
                currentInstitutions: [],
                defaultInstitutions: []
            };

            plaidObj.create = function (options) {
                /*jshint -W030 */
                options || ( options = {} );
                /*jshint +W030 */
                var config = {};

                options = angular.extend({}, configDefaults, options);
                angular.extend(config, options);

                config.onLoad = function() {
                    console.log('loaded');
                    plaidObj.loaded = true;
                    if (typeof options.onLoad === "function") {
                        options.onLoad.apply(null, arguments);
                    }
                };
                config.onSuccess = function(public_token, metaData) {
                    plaidObj.bank.public_token = public_token;
                    plaidObj.bank.meta = metaData;

                    plaidObj.currentInstitutions.forEach(function(inst) {
                        if (inst.institution_id === metaData.institution.institution_id) {
                            plaidObj.bank.data = inst;
                        }
                    });

                    if (typeof options.onSuccess === "function") {
                        options.onSuccess.apply(null, arguments);
                    }
                };
                config.onExit = function() {
                    if (typeof options.onExit === "function") {
                        options.onExit.apply(null, arguments);
                    }
                };

                plaidObj.handler = Plaid.create(config);

                return plaidObj.handler;
            };

            plaidObj.getHandler = function() {
                return plaidObj.handler;
            };

            plaidObj.open = function (institutionId) {
                plaidObj.handler.open(institutionId);
            };

            plaidObj.retrieveStatus = function() {
                plaidObj.enabled = true;
                // return Request.make('plaid_status').then(function(response) {
                //     plaidObj.enabled = true;
                // }).catch(function() {
                //     plaidObj.enabled = false;
                //     plaidObj.show = false;
                // });
            };

            plaidObj.retrieveDefaultInstitutions = function() {
                if (!Object.keys(plaidObj.defaultInstitutions).length) {
                    return Request.make('plaid_default').then(function(response) {
                        plaidObj.defaultInstitutions = response.data.response;
                        plaidObj.defaultInstitutions.forEach(function(ins) {
                            ins.logo = false;
                        });
                        plaidObj.currentInstitutions = plaidObj.defaultInstitutions;
                        return plaidObj.defaultInstitutions;
                    }).catch(function() {

                    });
                } else {
                    plaidObj.currentInstitutions = plaidObj.defaultInstitutions;
                    return $q.when(plaidObj.defaultInstitutions);
                }
            };

            plaidObj.retrieveSearchInstitutions = function(query) {
                    return Request.make('plaid_search', {query: query}).then(function(response) {
                        plaidObj.currentInstitutions = response.data.response;
                        return plaidObj.currentInstitutions;
                    }).catch(function() {

                    });
            };

            plaidObj.retrievePlaidBankToken = function(bank_uuid) {
                return Request.make('bank_plaid_token', {uuid: bank_uuid}).then(function(response) {
                    return response.data.public_token;
                });
            };

            plaidObj.retrievePlaidAddToken = function(data = {}, refresh) {
                if (plaidObj.addToken && !refresh) {
                    return $q.when(plaidObj.addToken.add_token);
                } else {
                    let requestKey = 'bank_plaid_add_token';
                    if (data.code) {
                        requestKey = 'signup_plaid_add_token';
                    }
                    return Request.make(requestKey, data).then(function (response) {
                        plaidObj.addToken = response.data;
                        return plaidObj.addToken.add_token;
                    });
                }
            };

            /**
             *
             * @param {uuid} bank_uuid
             * @param {String} status "success" or "fail"
             * @param {Object} data
             * @param {Array} data.error
             * @returns {Promise<any>}
             */
            plaidObj.updatePlaidMicros = function(bank_uuid, status, data = {}) {
                data.uuid = bank_uuid;
                data.status = status;
                return Request.make('bank_plaid_update_micros', data).then(function(response) {
                    return response.data;
                });
            };

            plaidObj.getWebhook = function(invite) {
                return Request.url('plaid_webhook', {inviteCode: invite});
            };

            plaidObj.toggleView = function() {
                if (plaidObj.show) {
                    if (plaidObj.bank.accountsLoaded) {
                        plaidObj.bank.accountsLoaded = false;
                    } else {
                        plaidObj.show = !plaidObj.show;
                    }
                } else {
                    plaidObj.show = !plaidObj.show;
                }
            };
            
            plaidObj.clear = function() {
                plaidObj.bank = {
                    accountsLoaded: false,
                    imageLoaded: false,
                    public_token: null,
                    data: {},
                    meta: {},
                    accounts: []
                };
                plaidObj.errorMsg = null;
            };

            plaidObj.retrieveStatus();

            return plaidObj;
        }];

        return this;

    }]);

})();
